"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AirwebTicketLegacyOrderService = void 0;
class AirwebTicketLegacyOrderService {
    constructor(client) {
        this.client = client;
    }
    async placeOrder(userToken, order, options = {}) {
        const response = (await this.client.http
            .post('Order/placeOrder.json', Object.assign(Object.assign({}, order), { userToken }), options)
            .catch(this.handleError));
        return Object.assign(Object.assign({}, response.data.user), { order_id: response.data.order.id, network_id: response.data.order.network_id });
    }
    async computeAmount(userToken, data, options = {}) {
        const response = (await this.client.http
            .post('Order/computeAmount.json', Object.assign(Object.assign({}, data), { userToken }), options)
            .catch(this.handleError));
        return response.data;
    }
    async printOrder(userToken, orderId, options = {}) {
        const response = (await this.client.http
            .post('Order/printOrder.json', { orderId, userToken }, Object.assign({ responseType: 'blob' }, options))
            .catch(this.handleError));
        return response.data;
    }
    async history(userToken, options = {}) {
        const response = (await this.client.http
            .get('Order/history.json', Object.assign({ params: { userToken } }, options))
            .catch(this.handleError));
        return response.data.history;
    }
    async getOrders(userToken, networkId, options = {}) {
        const response = (await this.client.http
            .get('Order/getOrders.json', Object.assign({ params: { userToken, networkId } }, options))
            .catch(this.handleError));
        return response.data;
    }
    async getOrder(userToken, orderId, options = {}) {
        const response = (await this.client.http
            .get('Order/getOrders.json', Object.assign({ params: { userToken, orderId } }, options))
            .catch(this.handleError));
        return response.data.find((o) => o.id == orderId);
    }
    async create(userToken, order, options = {}) {
        const body = Object.assign({ userToken }, order);
        if (options.locale)
            body.locale = options.locale;
        const response = (await this.client.http
            .post('Order/create.json', body, options)
            .catch(this.handleError));
        return response.data;
    }
    async redeemVoucher(redeemParams, options = {}) {
        const response = (await this.client.http
            .post('Order/redeemVoucher.json', redeemParams, options)
            .catch(this.handleError));
        return response.data;
    }
    async verify(userToken, order, options = {}) {
        const response = (await this.client.http
            .post('Order/verify.json', Object.assign({ userToken }, order), options)
            .catch(this.handleError));
        return response.data;
    }
    handleError(error) {
        throw error;
    }
}
exports.AirwebTicketLegacyOrderService = AirwebTicketLegacyOrderService;
//# sourceMappingURL=order.service.js.map